import { Component, Injector, Input } from '@angular/core';
import { provideValueAccessor } from 's-ng-utils';
import { CustomFormControl, Wrapper } from 'bookraw/shared/components/form-input/wrapper';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'ext-input',
  template: `
    <ng-container *ngIf="bookrawStyle; else defaultStyle">
      <div class="custom-rounded-form-input">
        <label *ngIf="label">{{ label }}</label>
        <input
          [attr.disabled]="disabled"
          [class]="classes.join(' ')"
          [formControl]="formControl"
          [required]="formControl.markRequired || required"
          [type]="type"
          [placeholder]="placeholder"
        />
        <mat-error *ngFor="let error of errorMessages(formControl)">{{ error }}</mat-error>
      </div>
    </ng-container>
    <ng-template #defaultStyle>
      <mat-form-field
        [class.full-width]="fullWidth"
        [style.width]="widthPercent + '%'"
        appearance="standard"
        matTooltip="{{ tooltip }}"
        matTooltipPosition="above"
        [class.mat-form-field-invalid]="ngControl.invalid"
      >
        <mat-label>{{ label }}</mat-label>
        <input
          #input
          matInput
          [attr.disabled]="disabled"
          [type]="visibilityIconSuffix ? (hidePassword ? 'password' : 'text') : type"
          [min]="min"
          [max]="max"
          [formControl]="formControl"
          [maxlength]="maxlength"
          [required]="formControl.markRequired || required"
          [placeholder]="placeholder"
          [class]="classes.join(' ')"
        />
        <span matPrefix *ngIf="matPrefix"><mat-icon>{{ prefixIcon }}</mat-icon></span>
        <span matSuffix *ngIf="visibilityIconSuffix">
          <mat-icon (click)="hidePassword = !hidePassword" style="cursor: pointer; position: relative; top: 5px;">
            {{ hidePassword ? 'visibility_off' : 'visibility' }}
          </mat-icon>
        </span>
        <mat-hint *ngIf="maxlength.length > 0" align="end">{{input.value?.length || 0}}/{{ maxlength }}</mat-hint>
        <mat-error>{{ formControl?.getError('error') }}</mat-error>
      </mat-form-field>
      <mat-error [style]="i === 0 ? 'margin-top: -15px' : ''" *ngFor="let error of errorMessages(formControl); index as i">{{ error }}</mat-error>
    </ng-template>
  `,
  providers: [provideValueAccessor(ExtInputComponent)],
})
export class ExtInputComponent extends Wrapper {
  @Input() type: string = 'text';
  @Input() disabled?: boolean = false;
  @Input() label: string = '';
  @Input() inputName?: string = 'This field';
  @Input() maxlength: string = '';
  @Input() min?: number = 0;
  @Input() max?: number;
  @Input() fullWidth?: boolean = true;
  @Input() widthPercent?: number;
  @Input() matPrefix?: boolean = false;
  @Input() prefixIcon?: string = '';
  @Input() visibilityIconSuffix?: boolean = false;
  @Input() bookrawStyle: boolean = false;
  @Input() placeholder: string = '';
  @Input() classes?: string[] = [];

  hidePassword: boolean = true;

  constructor(
    public injector: Injector,
    public translate: TranslateService
  ) {
    super(injector);
  }

  public errorMessages(formControl: CustomFormControl): string[] {
    const errorMessages: string[] = [];

    if (formControl.touched && formControl.errors) {
      if (formControl.errors['required'] || formControl.errors['required_with']) errorMessages.push(this.inputName + this.translate.instant('validation.required'));
      if (formControl.errors['email']) errorMessages.push(this.translate.instant('validation.email'));
      if (formControl.errors['validateEmail']) errorMessages.push(this.translate.instant('validation.email'));
      if (formControl.errors['min']) errorMessages.push(this.translate.instant('validation.min'));
      if (formControl.errors['max']) errorMessages.push(this.translate.instant('validation.max'));
      if (formControl.errors['mustMatch']) errorMessages.push(this.translate.instant('validation.password_match'));
      if (formControl.errors['incorrectPassword']) errorMessages.push(this.translate.instant('validation.password_original'));
      if (formControl.errors['validatePassword']) errorMessages.push(this.translate.instant('validation.password'));
      if (formControl.errors['regex']) errorMessages.push(this.translate.instant('validation.regex'));
      if (formControl.errors['unique']) errorMessages.push(this.translate.instant('validation.unique'));
    }

    return errorMessages;
  }
}
